import { render, staticRenderFns } from "./QuickSearchStandard.vue?vue&type=template&id=972c7cb2"
import script from "./QuickSearchStandard.vue?vue&type=script&lang=js"
export * from "./QuickSearchStandard.vue?vue&type=script&lang=js"
import style0 from "./QuickSearchStandard.vue?vue&type=style&index=0&id=972c7cb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports